import type { ReactElement } from 'react';

import { SidebarContent } from './SidebarContent';

/** Sidebar permanente de escritorio. En móvil se oculta (CSS) y su contenido
 *  se ofrece por el drawer (ver MobileNav). */
export function Sidebar(): ReactElement {
  return (
    <aside className="side">
      <SidebarContent />
    </aside>
  );
}
